function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import React from 'react';
import PropTypes from 'prop-types';
import Pagination from 'react-js-pagination';
import ProductTotals from './product-totals';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Toolbar = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Toolbar, _React$PureComponent);
  var _super = _createSuper(Toolbar);
  function Toolbar() {
    _classCallCheck(this, Toolbar);
    return _super.apply(this, arguments);
  }
  _createClass(Toolbar, [{
    key: "render",
    value: function render() {
      var gridSVG = /*#__PURE__*/_jsx("svg", {
        width: "13",
        height: "13",
        viewBox: "0 0 13 13",
        children: /*#__PURE__*/_jsx("path", {
          d: "M0 0h3v3H0zm0 5h3v3H0zm5-5h3v3H5zm0 5h3v3H5zm5-5h3v3h-3zm0 5h3v3h-3zM0 10h3v3H0zm5 0h3v3H5zm5 0h3v3h-3z",
          fillRule: "evenodd"
        })
      });
      var gridWording = 'Grid';
      var windowW = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
      if (windowW <= 768) {
        gridSVG = /*#__PURE__*/_jsx("svg", {
          width: "12",
          height: "13",
          viewBox: "0 0 12 13",
          xmlns: "http://www.w3.org/2000/svg",
          children: /*#__PURE__*/_jsxs("g", {
            fillRule: "evenodd",
            children: [/*#__PURE__*/_jsx("path", {
              d: "M0 0h12v6H0z"
            }), /*#__PURE__*/_jsx("path", {
              d: "M0 7h12v6H0z"
            })]
          })
        });
        gridWording = 'Large';
      }
      var nextIcon = /*#__PURE__*/_jsx("svg", {
        width: "9",
        height: "14",
        viewBox: "0 0 9 14",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/_jsx("path", {
          d: "M.295 12.29l1.41 1.42 6.71-6.67L1.708.294.29 1.705 5.587 7.03",
          fillRule: "nonzero"
        })
      });
      var prevIcon = /*#__PURE__*/_jsx("svg", {
        width: "9",
        height: "14",
        viewBox: "0 0 9 14",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/_jsx("path", {
          d: "M8.41 1.713L7 .295.29 6.965l6.706 6.744 1.418-1.41L3.12 6.972",
          fillRule: "nonzero"
        })
      });
      var firstIcon = /*#__PURE__*/_jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 11.26 9.77",
        width: "11",
        height: "10",
        children: [/*#__PURE__*/_jsx("path", {
          d: "M5.91 1l-1-1L0 4.86l4.88 4.91 1-1-3.82-3.91"
        }), /*#__PURE__*/_jsx("path", {
          d: "M11.26 1l-1-1-4.91 4.86 4.88 4.91 1-1-3.82-3.91"
        })]
      });
      var lastIcon = /*#__PURE__*/_jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "11",
        height: "10",
        viewBox: "0 0 11.26 9.77",
        children: [/*#__PURE__*/_jsx("path", {
          d: "M5.35 8.74l1 1 4.89-4.86L6.38 0l-1 1L9.2 4.91"
        }), /*#__PURE__*/_jsx("path", {
          d: "M0 8.74l1 1 4.92-4.83L1 0 0 1l3.86 3.91"
        })]
      });
      return /*#__PURE__*/_jsxs("div", {
        className: "l-toolbar".concat(this.props.variation ? " l-toolbar--".concat(this.props.variation) : ''),
        children: [/*#__PURE__*/_jsx(ProductTotals, {
          total: this.props.totalProducts,
          start: this.props.start,
          end: this.props.end
        }, "totals"), this.props.layout ? /*#__PURE__*/_jsxs("div", {
          className: "l-toolbar__layouts",
          children: [/*#__PURE__*/_jsxs("button", {
            className: "l-toolbar__layout ".concat(this.props.layout === 'grid' ? 'is-active' : null),
            value: "grid",
            onClick: this.props.changeLayout,
            children: [/*#__PURE__*/_jsx("div", {
              className: "sr-only",
              children: gridWording
            }), gridSVG]
          }), /*#__PURE__*/_jsxs("button", {
            className: "l-toolbar__layout ".concat(this.props.layout === 'list' ? 'is-active' : null),
            value: "list",
            onClick: this.props.changeLayout,
            children: [/*#__PURE__*/_jsx("div", {
              className: "sr-only",
              children: "List"
            }), /*#__PURE__*/_jsx("svg", {
              width: "14",
              height: "14",
              xmlns: "http://www.w3.org/2000/svg",
              children: /*#__PURE__*/_jsx("path", {
                d: "M0 0h3v2H0zM0 4h3v2H0zM0 8h3v2H0zM0 12h3v2H0zM5 0h9v1.979H5zM5 4h9v1.979H5zM5 8h9v1.979H5zM5 12h9v1.979H5z"
              })
            })]
          })]
        }) : '', this.props.sort ? /*#__PURE__*/_jsxs("div", {
          className: "l-toolbar__sort",
          children: [/*#__PURE__*/_jsx("div", {
            className: "l-toolbar__sort-label",
            children: "Order by:"
          }), /*#__PURE__*/_jsxs("div", {
            className: "l-form__select l-toolbar__sort-select",
            children: [/*#__PURE__*/_jsxs("select", {
              className: "l-toolbar__sort-input l-form__input l-form__input--select",
              onChange: this.props.changeSort,
              defaultValue: this.props.sort,
              children: [/*#__PURE__*/_jsx("option", {
                value: "popularity",
                children: "Popularity"
              }), /*#__PURE__*/_jsx("option", {
                value: "az",
                children: "Alphabetical A-Z"
              }), /*#__PURE__*/_jsx("option", {
                value: "za",
                children: "Alphabetical Z-A"
              })]
            }), /*#__PURE__*/_jsx("svg", {
              width: "12",
              height: "6",
              xmlns: "http://www.w3.org/2000/svg",
              children: /*#__PURE__*/_jsx("path", {
                d: "M12 0L6.222 6 0 0z",
                fill: "#FDCA35",
                fillRule: "evenodd"
              })
            })]
          })]
        }) : '', this.props.totalProducts > this.props.pageLength ? /*#__PURE__*/_jsx("div", {
          className: "l-toolbar__pagination",
          children: /*#__PURE__*/_jsx(Pagination, {
            activePage: this.props.activePage,
            itemsCountPerPage: this.props.pageLength,
            totalItemsCount: this.props.totalProducts,
            pageRangeDisplayed: 3,
            prevPageText: prevIcon,
            firstPageText: firstIcon,
            nextPageText: nextIcon,
            lastPageText: lastIcon,
            hideFirstLastPages: true,
            innerClass: "c-pagination",
            itemClass: "c-pagination__item",
            linkClass: "c-pagination__link",
            activeLinkClass: "c-pagination__current",
            linkClassPrev: "c-pagination__prev-link",
            linkClassNext: "c-pagination__next-link",
            linkClassFirst: "c-pagination__first-link",
            linkClassLast: "c-pagination__last-link",
            onChange: this.props.handlePageChange,
            hideNavigation: this.props.totalProducts <= this.props.pageLength,
            hideDisabled: true
          })
        }) : '']
      });
    }
  }]);
  return Toolbar;
}(React.PureComponent);
Toolbar.defaultProps = {
  changeLayout: function changeLayout() {},
  layout: '',
  changeSort: function changeSort() {},
  sort: '',
  variation: ''
};
Toolbar.propTypes = {
  changeLayout: PropTypes.func,
  layout: PropTypes.string,
  changeSort: PropTypes.func,
  sort: PropTypes.string,
  totalProducts: PropTypes.number.isRequired,
  pageLength: PropTypes.number.isRequired,
  activePage: PropTypes.number.isRequired,
  handlePageChange: PropTypes.func.isRequired,
  start: PropTypes.number.isRequired,
  end: PropTypes.number.isRequired,
  variation: PropTypes.string
};
export default Toolbar;